import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a7553a4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/wallet/_wallet.scss?vue&type=style&index=0&id=3a7553a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7553a4",
  null
  
)

export default component.exports